<template>
  <div class="bg-dark m-b-30">
      <div class="container">
          <div class="row p-b-60 p-t-30">
              <div class="col-md-6 text-center mx-auto text-white p-b-30">
                  <p class="h6">OSUN HEALTH INSURANCE SCHEME</p>
                  <div class="form-dark">
                      <div class="input-group input-group-flush mb-3">

                      </div>
                      <p>Version 3.1 &#169; 2025</p>
                  </div>

              </div>


          </div>
      </div>
  </div>

</template>

<script>


export default {

  components: {
    // HelloWorld
  },
  data(){
    return{
      auth_user:""

    }
  },
  beforeMount(){
  //
  },
  methods:{
    //
  },
  created(){
    //
  }
}
</script>
